export const TELEMETRY_SESSION_KEY = "telemetry.sessionId";
